// Task 12 (WU-2.3) — doc-anchored note surface in the Verification Station.
// QueueInstructionStrip precedent (WU-2.2): self-fetching via its own hook,
// WS-merged, null-when-empty, mounted OUTSIDE the terminalMode branch so it
// renders in both standard and terminal VS modes. NEVER touches focus
// (F-077 — the station's keyboard flow is sacred): plain divs, no autofocus,
// no keydown handlers. Reuses NoteInboxItem for the ack+reply body so the
// interaction model matches the /notes inbox exactly.
import { memo } from "react";
import { useWsClient } from "@/lib/ws-provider";
import { isDirectedNoteActive } from "@capture/shared";
import { useDirectedNotes } from "../hooks/useDirectedNotes";
import { NoteInboxItem } from "./NoteInboxItem";
import styles from "../directed-notes.module.css";

export const DirectedNoteCard = memo(function DirectedNoteCard({
  documentId,
}: {
  documentId: string;
}) {
  const wsClient = useWsClient();
  const { notes, acknowledge } = useDirectedNotes(wsClient);
  const mine = notes.filter((n) => isDirectedNoteActive(n) && n.documentId === documentId);
  if (mine.length === 0) return null;
  return (
    <div
      className={styles.vsCard}
      data-testid="directed-note-card"
      role="status"
      data-vs-keyboard-exempt=""
    >
      {mine.map((n) => (
        <NoteInboxItem key={n.id} note={n} onAcknowledge={acknowledge} />
      ))}
    </div>
  );
});
